import { Card, notification, Statistic } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";

const StatisticCard = (props) => {
  const [count, setCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    axios
      .get(props.url)
      .then((res) => {
        setCount(res.data.length);
        setIsLoading(false);
      })
      .catch((err) => {
        notification.error({
          message: "Error Loading Data",
          description: err.response.data.message,
          placement: "topRight",
        });
      });
  }, []);

  return (
    <Card>
      <Statistic
        title={props.title}
        value={count}
        valueStyle={{ color: props.color }}
        loading={isLoading}
        prefix={props.icon}
      />
    </Card>
  );
};

export default StatisticCard;
